import { Chart as ChartJS } from 'chart.js';

export const ANALYTICS_TITLE_FONT_FAMILY = "'Montserrat', 'Open Sans', sans-serif";
export const ANALYTICS_BODY_FONT_FAMILY = "'Open Sans', sans-serif";
export const APP_BODY_FONT_FAMILY = "'Roboto', sans-serif";

// Shared Custom Analytics section typography tokens.
export const CUSTOM_ANALYTICS_SECTION_TITLE_STYLE = {
  fontFamily: APP_BODY_FONT_FAMILY,
  fontSize: '1.125rem',
  fontWeight: 700,
  lineHeight: 1.25,
  letterSpacing: '0.01em',
  textTransform: 'none',
  color: '#202124',
};

export const CUSTOM_ANALYTICS_SECTION_DESCRIPTION_STYLE = {
  fontFamily: APP_BODY_FONT_FAMILY,
  fontSize: '0.875rem',
  fontWeight: 400,
  lineHeight: 1.45,
  color: 'rgba(0, 0, 0, 0.72)',
};

let chartJsTypographyApplied = false;

export function applyAnalyticsChartTypographyDefaults() {
  if (chartJsTypographyApplied) {
    return;
  }
  chartJsTypographyApplied = true;

  ChartJS.defaults.font.family = ANALYTICS_BODY_FONT_FAMILY;
  ChartJS.defaults.font.size = 12;

  ChartJS.defaults.plugins.legend.labels.font = {
    family: ANALYTICS_BODY_FONT_FAMILY,
    size: 12,
    weight: '400',
  };

  ChartJS.defaults.plugins.title.font = {
    family: ANALYTICS_TITLE_FONT_FAMILY,
    size: 14,
    weight: '600',
  };

  ChartJS.defaults.plugins.tooltip.titleFont = {
    family: ANALYTICS_BODY_FONT_FAMILY,
    size: 12,
    weight: '600',
  };
  ChartJS.defaults.plugins.tooltip.bodyFont = {
    family: ANALYTICS_BODY_FONT_FAMILY,
    size: 12,
    weight: '400',
  };
  ChartJS.defaults.plugins.tooltip.footerFont = {
    family: ANALYTICS_BODY_FONT_FAMILY,
    size: 12,
    weight: '400',
  };
  ChartJS.defaults.plugins.tooltip.backgroundColor = '#FFFFFF';
  ChartJS.defaults.plugins.tooltip.titleColor = '#1F1F1F';
  ChartJS.defaults.plugins.tooltip.bodyColor = '#333333';
  ChartJS.defaults.plugins.tooltip.footerColor = '#333333';
  ChartJS.defaults.plugins.tooltip.borderColor = 'rgba(0, 0, 0, 0.10)';
  ChartJS.defaults.plugins.tooltip.borderWidth = 1;
  ChartJS.defaults.plugins.tooltip.cornerRadius = 12;
  ChartJS.defaults.plugins.tooltip.padding = 12;
  ChartJS.defaults.plugins.tooltip.boxPadding = 4;
  ChartJS.defaults.plugins.tooltip.caretSize = 6;
}
